import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

import { ISubTheme } from 'interfaces'

type CreateTopicProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateTopic: React.FC<CreateTopicProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  const { selectProps: subThemeSelectProps } = useSelect<ISubTheme>({
    resource: 'sub_themes',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.sub_theme_id) {
      values.name = values?.name?.trim()
      const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'topics')
      if (isNameRepeated && isNameRepeated?.topics?.length === 0) {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            created_by: user?.id,
          })
        )
      } else {
        message.error("Can't add topic with repeated name...")
      }
    } else {
      message.error('expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Create Topic">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('topics', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Topic"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: true }]}>
          <Select {...subThemeSelectProps} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
